import { Scenarios } from '@jfs/network'

const doesBeneficiaryAlreadyExist = {
  default: [
    {
      url: /beneficiary\/check/,
      method: 'GET',
      response: {
        status: 'SUCCESS',
        code: '40009',
        message: 'Beneficiary Does not Exist',
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /beneficiary\/check/,
      method: 'GET',
      responseCode: 500,
      response: {
        status: 'FAILURE',
        error: {
          message: 'Beneficiary Already Exist',
          code: '40008',
        },
      },
      delay: 1000,
    },
  ],
} as Scenarios

export { doesBeneficiaryAlreadyExist }
